'use client';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

import { ContactHero } from '../contact-hero';
import { ContactInfo } from '../contact-info';
import { ContactForm } from '../contact-form';

export function ContactView() {
  return (
    <>
      <ContactHero />

      <Box component="main" sx={{ bgcolor: 'background.default', pb: { xs: 10, md: 14 } }}>
        <Container sx={{ pt: { xs: 6, md: 10 } }}>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', md: '1fr 1.6fr' },
              gap: { xs: 6, md: 10 },
              alignItems: 'start',
            }}
          >
            <ContactInfo />
            <ContactForm />
          </Box>
        </Container>
      </Box>
    </>
  );
}
